import CustomInput from '../../components/TextInput'
import { TEducationalInfo, TProfessionalInfo } from '../../hooks/useFormRegister'
import { UserDTO } from '../../models/users'
import { RegisterFormInfoTypes } from '../../helpers/enums'
import PendingUserFormList from './PendingUserFormList'
import {
    dateFormatter,
    mapUserEducationDTOtoEducationInfo,
    mapUserWorkDTOtoProfessionalInfo,
} from '../../helpers/utils'
import { IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'

interface Props {
    info: UserDTO
    handleClose: () => void
}

const PendingUserForm = ({ info, handleClose }: Props) => {
    return (
        <div className="flex flex-col gap-2 md:gap-4">
            <div className="flex items-center">
                <span className="md:my-3 text-base md:text-xl">Información personal</span>
                <IconButton
                    onClick={handleClose}
                    className="ml-auto p-0 text-primary"
                >
                    <ClearIcon />
                </IconButton>
            </div>
            <div className="h-[115px] md:h-[140px]">
                <div className="flex items-center gap-2 md:gap-4 h-full">
                    <div
                        className={`ml-2 h-full aspect-square rounded-full outline outline-primary -outline-offset-1 outline-[2px]`}
                    >
                        <img
                            width="100%"
                            height="100%"
                            alt="userImage"
                            src={!!info.picture ? info.picture : '/adminPhoto.png'}
                            className="rounded-full"
                        />
                    </div>
                    <div className="flex flex-col gap-2 md:gap-4 w-full">
                        <CustomInput
                            type="text"
                            label="Nombres"
                            value={info.firstName}
                            disabled
                        />
                        <CustomInput
                            type="text"
                            label="Apellidos"
                            value={info.lastName}
                            disabled
                        />
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mt-1 md:mt-3">
                <CustomInput
                    label="Teléfono"
                    value={info.phone}
                    disabled
                />
                <CustomInput
                    label="Fecha de nacimiento"
                    value={dateFormatter(new Date(info.dateOfBirth))}
                    disabled
                />
                <CustomInput
                    label="Nacionalidad"
                    value={info.nationality}
                    disabled
                />
                <CustomInput
                    value={info.livesAbroad ? 'Si' : 'No'}
                    label="¿Vive en el extranjero?"
                    disabled
                />
            </div>
            <PendingUserFormList<TProfessionalInfo>
                infoArray={mapUserWorkDTOtoProfessionalInfo(info.workHistories)}
                title="Información Profesional"
                type={RegisterFormInfoTypes.Professional}
            />
            <PendingUserFormList<TEducationalInfo>
                infoArray={mapUserEducationDTOtoEducationInfo(info.educationalHistories)}
                title="Educación"
                type={RegisterFormInfoTypes.Educational}
            />
        </div>
    )
}

export default PendingUserForm
